module.exports = __webpack_public_path__ + "img/logo_Q_W.56f6f889.svg";